<template>
  <a :href="buildHrefLink()" class="img-a-button" @click="handleEmailShare()">
    <img src="@/assets/btn-email.png" alt="Share via email" />
  </a>
</template>

<script>
import { trackEvent } from "@/analytics";
export default {
  props: ["currentUser", "score", "referralUrl"],
  methods: {
    handleEmailShare() {
      trackEvent("shared");
    },
    buildHrefLink() {
      const subjectParam = "Do you remember this? 🐍";
      const refParam = this.currentUser ? "?ref=" + this.currentUser.uid : "";
      const invitationPrompt = "You've been invited";
      return `mailto:?subject=${subjectParam}&body=${invitationPrompt} to play a game of snake, just as it used to be all those years ago!
      %0D%0A%0D%0AFor every friend that plays with you, you both earn bonus points and climb up the leaderboard to win amazing prizes!
      %0D%0A%0D%0ACome to the fang side - play here: ${this.referralUrl}`;
    }
  }
};
</script>